<template>
  <v-dialog
    v-model="modal"
    :max-width="width"
    :persistent="persistent"
    :fullscreen="fullscreen"
    @input="$emit('close')"
  >
    <v-card color="grey lighten-4">
      <v-card-title
        class="pa-3 body-1 d-flex justify-space-between"
        :class="cardTitleClass"
        :style="fixedTitle && fixedTitleStyles"
        id="modal-nav"
      >
        <slot name="title">
          {{ title }}
          <div v-if="!!titleIcons.length">
            <v-btn
              v-for="(icon, i) of titleIcons"
              :key="i"
              fab text small :dark=icon.dark
              :loading="icon.loading ? loading : false"
              @click="$emit(icon.event)"
            ><v-icon>{{ icon.name }}</v-icon>
            </v-btn>
          </div>
        </slot>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text id="modal-body" :class="cardBodyClass" :style="fixedTitle && cardContainerStyles">
        <slot></slot>
      </v-card-text>
      <v-divider  v-if="hasActions"></v-divider>
      <v-card-actions class="justify-end" v-if="hasActions">
        <v-btn color="blue darken-1" text @click="$emit('close')">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="$emit('save')">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    cardTitleClass: {
      type: String,
      default: ''
    },
    cardBodyClass: {
      type: String,
      default: 'pa-3'
    },
    width: {
      type: String,
      default: '300px'
    },
    persistent: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    titleIcons: {
      type: Array,
      default: () => [
        { name: 'mdi-refresh', event: 'refresh', loading: true }
      ]
    },
    hasActions: {
      type: Boolean,
      default: true
    },
    fixedTitle: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    modal(value) {
      this.$emit('modalChanged', value);
    }
  },
  computed: {
    fixedTitleStyles() {
      return {
        overflow: 'hidden',
        position: 'fixed',
        top: '0',
        width: '100%',
        zIndex: '1'
      }
    },
    cardContainerStyles() {
      return {
        marginTop: '60px',
        zIndex: '-1'
      }
    }
  }
}
</script>

<style scoped>
@media print {
  #modal-nav {
    display: none !important;
  }
  #modal-body {
    margin: 0 !important;
  }
}
</style>